<template>
	<div class="sg-center-padding dashboard-wrap">
		<div id="shouye">
			<vehicle-swiper-inform
				ref="first"
				:tab-type="tabType"
				@scroll="handleScroll"
				@login="loginDialogVisible = $event"
				:listActivity="listActivity"
			/>
		</div>
		<div id="activity" class="activity-box" v-if="Name != ''">
			<activity ref="second" />
		</div>
		<div class="complex-box">
			<shop ref="third" id="shop" @login="loginDialogVisible = $event" />
			<vehicle-source
				ref="fourth"
				id="source"
				@login="loginDialogVisible = $event"
			/>
			<auction ref="fifth" id="auction" @login="loginDialogVisible = $event" />
			<recommend @login="loginDialogVisible = $event" />
		</div>
		<div class="right-wrap">
			<right-menu @scroll="handleScroll" :tab-type="tabType" />
		</div>
		<el-dialog
			custom-class="sg-login-dialog"
			:visible.sync="loginDialogVisible"
			title="请先登录"
			width="400px"
		>
			<login></login>
		</el-dialog>
	</div>
</template>
<script>
import {TopActiveBanner} from "@/api/activity.js"
// import vueSeamlessScroll from "vue-seamless-scroll";
import Login from "@/components/Login"
// import { mapState } from "vuex";
// import { IndexUnLogin, VehicleStructure } from "@/api/merchant/dashboard";
import {IndexUnLogin} from "@/api/merchant/dashboard"
import Shop from "./components/shop"
import VehicleSource from "./components/source"
import Auction from "./components/auction"
import Activity from "./components/activity"
import VehicleSwiperInform from "./components/vehicleSwiperInform"
import Recommend from "./components/recommend"
import RightMenu from "./components/rightMenu"
import ScrollIntoView from "@/utils/mixins/scrollIntoView.js"

export default {
	mixins: [ScrollIntoView],
	components: {
		Login,
		// vueSeamlessScroll,
		Shop,
		VehicleSource,
		Auction,
		Activity,
		VehicleSwiperInform,
		Recommend,
		RightMenu
	},
	provide: function () {
		return {
			getShopList: () => this.list.Item1,
			getSourceList: () => this.list.Item2,
			getAuctionList: () => this.list.Item3,
			getRecommendList: () => this.list.Item4
			// getAuctionList: () => this.list.Item3,
			// getRecommendList: () => this.list.Item4,
		}
	},

	computed: {
		// ...mapState({
		//   device: (state) => state.app.device
		// }),
		// bgStyle() {
		//   if (this.carouselIndex == 0) {
		//     return { "background-color": "rgb(0, 1, 111)" };
		//   } else {
		//     return { "background-color": "rgb(17, 143, 47)" };
		//   }
		// },
	},
	// filters: {
	//   icon: function (value) {
	//     if (!value) return "";
	//     switch (value) {
	//       case "001": //车身部分
	//         return require("@/assets/tourist/cs.png");
	//       case "002": //电器照明系统
	//         return require("@/assets/tourist/zm.png");
	//       case "003": //发动机与变速器
	//         return require("@/assets/tourist/fdj.png");
	//       case "004": //底盘部分
	//         return require("@/assets/tourist/dp.png");
	//     }
	//     // value = value.toString();
	//     // return value.charAt(0).toUpperCase() + value.slice(1);
	//   },
	// },
	// beforeRouteEnter(to,from,next){
	//  debugger
	//  next()
	// },
	watch: {
		// tabType(val) {
		//   this.scrollToElePosition(val)
		//   // console.log(val)
		//   // document.getElementById(`${val}`).scrollIntoView({
		//   //   behavior: "smooth",
		//   // });
		//   //  document.getElementById(`${val}`).scrollIntoView({behavior: 'smooth', block: 'center'});
		// },
	},
	data() {
		return {
			Name: "",
			// classification:[{title:"车身部分",content:[{
			//   text:
			// }]}],
			// classList: [],
			// navList: [
			//   { navName: "首页", navIcon: "icon" },
			//   { navName: "配件商城", navIcon: "icon" },
			//   { navName: "精品车源", navIcon: "icon" },
			//   { navName: "竞价中心", navIcon: "icon" },
			// ],

			// // num: 0,
			// carouselIndex: 0,
			// tabIndex: 0,
			xunjiaDialogVisible: false,
			loginDialogVisible: false,
			list: [],
			listActivity: [] //活动
			// list: {
			//   Item1: {
			//     endObj: {},
			//   },
			//   Item2: { endObj: {} },
			//   Item3: { endObj: {} },
			// },
			// tabType: "shouye",
			// activityList: [
			//   // {
			//   //   url: "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
			//   //   name: "倒车镜总成",
			//   //   vehicle: "2011款 上汽大众 帕萨特 三厢2.0L手动档 尊享版",
			//   //   terminalPrice: 30,
			//   //   price: 50,
			//   // },
			// ],
			// url: "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
			// activityOptions: {
			//   limitMoveNum: 6,
			//   direction: 2,
			//   singleWidth: 235,
			// },
		}
	},
	// beforeMount() {
	//   // document.addEventListener("scroll", this.handleScroll);
	// },
	created() {
		TopActiveBanner().then((res) => {
			this.listActivity = res
			this.Name = this.listActivity[1].Name
			console.log(this.listActivity[1].Name)
			console.log(res)
		})
		IndexUnLogin({Browser: "PC"}).then((res) => {
			// Object.keys(res).forEach((item) => {
			//   res[item] = {
			//     firstObj: {},
			//     endObj: res[item].pop(),
			//     middleList: res[item].slice(0),
			//   };
			// });
			// let obj = res
			// obj.Item3 = obj.Item3.console.log(res)
			this.list = res
		})
		// VehicleStructure().then((res) => {
		//   this.classList = res;
		// });
		// let list = [];
		// for (let i = 0; i < 10; i++) {
		//   list.push({
		//     url: "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
		//     name: "倒车镜总成",
		//     vehicle: "2011款 上汽大众 帕萨特 三厢2.0L手动档 尊享版",
		//     terminalPrice: 30,
		//     price: 50,
		//   });
		// }
		// this.activityList = list;
	},

	methods: {
		handleScroll(val) {
			this.tabType = val
			this.scrollToElePosition(val)
		}
		// handleLogin(e){
		//   debugger

		// },

		// handleScroll(e) {
		//   let scrollTop =
		//     e.target.scrollTop ||
		//     window.pageYOffset ||
		//     document.documentElement.scrollTop ||
		//     document.body.scrollTop; // 滚动条偏移量
		//   let num = this.navList.length;
		//   ["shouye", "activity", "shop", "source", "auction"].forEach((item) => {
		//     if (document.querySelector("#" + item).offsetTop < scrollTop) {
		//       this.tabType = item;
		//     }
		//   });
		//   // for (let n = 0; n < num; n++) {
		//   //   if (document.querySelector("#div" + n).offsetTop < scrollTop + 40) {
		//   //     // this.num = n;
		//   //     this.tabIndex = n;
		//   //   }
		//   // }
		// },
		// navClick(index) {
		//   // this.num = index;
		//   this.tabIndex = index;
		//   let navPage = document.querySelector("#div" + index);

		//   document.documentElement.scrollTop = navPage.offsetTop - 20; //兼容大部分浏览器
		//   //window.scrollTo({      //不兼容ie
		//   // 'top':navPage.offsetTop - 20,
		//   // })
		// },
		// handleCarouselChange(e) {
		//   this.carouselIndex = e;
		// },
		// handleToTop() {
		//   if (this.isMoving) return;
		//   const start = window.pageYOffset;
		//   let i = 0;
		//   this.isMoving = true;
		//   this.interval = setInterval(() => {
		//     const next = Math.floor(this.easeInOutQuad(10 * i, start, -start, 500));
		//     if (next <= this.backPosition) {
		//       window.scrollTo(0, this.backPosition);
		//       clearInterval(this.interval);
		//       this.isMoving = false;
		//     } else {
		//       window.scrollTo(0, next);
		//     }
		//     i++;
		//   }, 16.7);
		// },
		// easeInOutQuad(t, b, c, d) {
		//   if ((t /= d / 2) < 1) return (c / 2) * t * t + b;
		//   return (-c / 2) * (--t * (t - 2) - 1) + b;
		// },
		// handleToTop() {
		//   var timer = setInterval(function () {
		//     let osTop =
		//       document.documentElement.scrollTop || document.body.scrollTop;
		//     let ispeed = Math.floor(-osTop / 5);
		//     document.documentElement.scrollTop = document.body.scrollTop =
		//       osTop + ispeed;
		//     if (osTop === 0) {
		//       clearInterval(timer);
		//     }
		//   }, 60);
		// },
	}
}
</script>
<style scoped lang="scss">
.dashboard-wrap {
	position: relative;
	margin: 0 110px;
}
.right-wrap {
	// position: absolute;
	position: fixed;

	// right: 9%;
	right: 5%;
	top: 50%;
	transform: translateY(-50%);
	z-index: 9;
	// right: -65px;
	// top: 590px;
}
// .top-box {
//   display: grid;
//   grid-template-columns: 225px 1fr;
//   height: 496px;
//   .top-left {
//     background-color: #1d2089;
//     border-radius: 10px;
//     color: rgba(255, 255, 255, 1);
//     padding: 10px 15px;
//     overflow: auto;
//     .classification-title {
//       font-size: 20px;
//       font-weight: 700;
//     }
//     .classification-box {
//       .classification-wrap {
//         margin-top: 18px;
//         .title {
//           display: flex;
//           align-items: center;
//           font-size: 16px;
//           font-weight: 500;
//           color: rgba(255, 255, 255, 1);

//           .title-name {
//             margin-left: 8px;
//           }
//         }
//         .content {
//           margin-top: 8px;
//           font-size: 12px;
//           font-weight: 400;
//           line-height: 20px;
//           color: rgba(255, 255, 255, 1);
//         }
//       }
//     }
//   }
//   .top-right {
//     display: grid;
//     grid-template-rows: 50px 1fr;
//     margin-left: 5px;
//     .type-box {
//       opacity: 1;
//       border-radius: 10px;
//       background: rgba(255, 255, 255, 1);
//       display: flex;
//       .type-item {
//         margin: 9px 10px;
//         padding: 0 48px 0 28px;
//         // line-height: 10px;
//         border-right: 2px solid rgba(204, 204, 204, 1);
//         display: flex;
//         align-items: center;
//         font-size: 16px;
//         font-weight: 700;
//         // color: rgba(29, 32, 137, 1);
//         color: rgba(56, 56, 56, 1);
//         // &::after {
//         //   display: block;
//         //   content: "";
//         //   width: 2px;
//         //   height: 30px;
//         //   background: rgba(204, 204, 204, 1);
//         // }
//       }
//       .activeColor {
//         color: rgba(29, 32, 137, 1);
//       }
//     }
//     .swiper-login-box {
//       // display: flex;
//       // align-items: center;
//       display: grid;
//       grid-template-columns: 1fr 225px;
//       margin-top: 5px;
//       .swiper-box {
//         // flex: 1;
//         height: 100%;
//         // border-radius: 10px;
//         // overflow: hidden;
//       }
//       .login-register-box {
//         // width: 225px;
//         margin-left: 5px;
//         border-radius: 10px;
//         background: rgba(255, 255, 255, 1);
//         padding: 23px 14px;
//         text-align: center;
//         .avatar-wrap {
//           display: flex;
//           justify-content: center;
//         }
//         .name-wrap {
//           margin: 15px 0;
//           text-align: center;
//           font-size: 16px;
//           font-weight: 400;
//           color: rgba(56, 56, 56, 1);
//         }
//         .button-wrap {
//           display: flex;
//           justify-content: space-around;
//         }
//         .order-wrap {
//           display: flex;
//           justify-content: space-around;
//           margin-top: 35px;
//           .order-num {
//             font-size: 22px;
//             font-weight: 500;
//             color: rgba(254, 118, 72, 1);
//           }
//           .order-type {
//             font-size: 14px;
//             font-weight: 400;
//             color: rgba(56, 56, 56, 1);
//           }
//         }
//         .other-wrap {
//           margin-top: 22px;
//           display: grid;
//           grid-template-columns: repeat(2, auto);
//           grid-template-rows: repeat(2, auto);
//           grid-row-gap: 18px;
//           justify-content: space-around;
//           // text-align: left;
//           .other-box {
//             display: flex;
//           }
//           .icon {
//             width: 18px;
//             height: 18px;
//           }
//           .icon-text {
//             margin-left: 7px;
//             font-size: 12px;
//             font-weight: 400;
//             color: rgba(0, 0, 0, 1);
//             flex: 1;
//             text-align: left;
//           }
//         }
//       }
//     }
//   }
// }
.activity-box {
	margin-top: 20px;
	// .activity-wrap {
	//   border-radius: 10px;
	//   background: rgba(254, 118, 72, 1);
	//   height: 350px;
	//   // padding: 0 18px 15px;
	//   .title-wrap {
	//     display: flex;
	//     align-items: center;
	//     padding-left: 23px;

	//     .title-one {
	//       font-size: 30px;
	//       font-weight: 700;
	//       color: rgba(255, 255, 255, 1);
	//     }
	//     .title-two {
	//       height: 33px;
	//       opacity: 1;
	//       background: linear-gradient(
	//         180deg,
	//         rgba(33, 212, 253, 1) 0%,
	//         rgba(183, 33, 255, 1) 100%
	//       );
	//       font-size: 20px;
	//       font-weight: 400;
	//       color: rgba(255, 255, 255, 1);
	//       border-radius: 25px;
	//       padding: 0 10px;
	//       margin-left: 12px;
	//     }
	//   }
	//   .seamless-scroll {
	//     // width: 235px*6;
	//     padding-left: 10px;
	//     height: 285px;
	//     overflow: hidden;
	//     // padding: 0 15px;
	//     .content-wrap {
	//       display: flex;
	//       .cotent-item-wrap {
	//         // margin: 0 15px;
	//         width: 220px;
	//         margin-right: 15px;
	//         height: 285px;
	//         background-color: white;
	//         border-radius: 10px;
	//         .content-item {
	//           padding: 12px;
	//           .content-img-wrap {
	//             margin-bottom: 9px;
	//             .avatar-image {
	//               width: 100%;
	//               height: 150px;
	//               object-fit: cover;
	//             }
	//           }
	//           .inform-wrap {
	//             .name-wrap {
	//               height: 24px;
	//               line-height: 24px;
	//               font-size: 16px;
	//               font-weight: 500;
	//               color: rgba(56, 56, 56, 1);
	//             }
	//             .vehicle-wrap {
	//               font-size: 12px;
	//               font-weight: 400;
	//               color: rgba(56, 56, 56, 1);
	//               margin-bottom: 11px;
	//             }
	//             .price-wrap {
	//               height: 36px;
	//               .activity-price {
	//                 font-size: 24px;
	//                 font-weight: 700;
	//                 color: rgba(254, 118, 72, 1);
	//               }
	//               .original-price {
	//                 margin-left: 5px;
	//                 font-size: 10px;
	//                 font-weight: 400;
	//                 text-decoration-line: line-through;
	//                 color: rgba(128, 128, 128, 1);
	//               }
	//             }
	//           }

	//           //  height: 285px;
	//           // background-color: white;
	//         }
	//         // margin-left: 15px;
	//         // width: 220px;
	//         // margin-left: 15px;
	//         // background-color: white;
	//       }
	//     }
	//   }
	// }
}
.complex-box {
	margin-top: 15px;
	// .shangcheng-box {
	//   .type-wrap {
	//     padding: 7px 0 7px 27px;
	//     border-radius: 10px;
	//     background: rgba(255, 255, 255, 1);
	//     display: flex;
	//     align-items: center;
	//     .type-title {
	//       font-size: 26px;
	//       font-weight: 500;

	//       color: rgba(29, 32, 137, 1);
	//     }
	//     .tag {
	//       position: relative;
	//       // padding: 15px 12px 15px 7px;
	//       padding-left: 7px;
	//       padding-right: 12px;
	//       padding-top: 5px;
	//       padding-bottom: 5px;
	//       background: linear-gradient(
	//         90deg,
	//         rgba(37, 117, 252, 1) 0%,
	//         rgba(106, 17, 203, 1) 100%
	//       );
	//       font-size: 16px;
	//       font-weight: 400;
	//       color: rgba(255, 255, 255, 1);
	//       border-radius: 6px;
	//       margin-left: 18px;
	//       &::before {
	//         position: absolute;
	//         content: "";
	//         border-width: 6px;
	//         border-style: solid;
	//         border-color: transparent rgba(37, 117, 252, 1) transparent
	//           transparent;
	//         left: -12px;
	//         top: 50%;
	//         transform: translateY(-50%);
	//       }
	//     }
	//   }
	// }
}

// .padding-20 {
//   padding: 20px;
// }

// .floor-btns {
//   position: fixed;
//   top: 50%;
//   left: 50%;
//   // left: 0;
//   width: 56px;
//   border-radius: 3px;
//   margin-left: calc(600px + 10px);
//   // margin-left: calc(80% + 5vw);
//   background-color: #fff;
//   -webkit-box-shadow: 0 0 1px rgb(0 0 0 / 10%);
//   box-shadow: 0 0 1px rgb(0 0 0 / 10%);
//   overflow: hidden;
//   -webkit-transform: translate(0, -50%);
//   -ms-transform: translate(0, -50%);
//   transform: translate(0, -50%);
//   z-index: 92;
//   .double-line {
//     padding: 14px 12px;
//     line-height: 14px;
//   }
//   .btn-return {
//     box-sizing: border-box;
//     // width: 56px;
//     // height: 56px;
//     padding: 13px 12px;
//     font-size: 0;
//     > i {
//       font-size: 16px;
//     }
//     > span {
//       display: inline-block;
//       font-size: 12px;
//       line-height: 14px;
//     }
//   }

//   > li {
//     position: relative;
//     font-size: 12px;
//     text-align: center;
//     transition: color 0.2s ease, background-color 0.2s ease;
//     cursor: pointer;
//     &:not(:last-child):after {
//       position: absolute;
//       right: 7px;
//       bottom: 0;
//       left: 7px;
//       border-bottom: 1px solid #ccc;
//       content: "";
//     }
//     &:hover {
//       color: #ff4f1a;
//     }
//     &.active {
//       background-image: linear-gradient(90deg, #ff751a, #ff4f1a);
//       background-color: #ff4f1a;
//       color: #fff;
//       &:not(:last-child):after {
//         border-bottom: 1px solid #ff4f1a;
//       }
//     }
//   }
// }
// .contScroll {
//   .full-screen-top {
//     background-color: #fff;
//     display: inline-block;
//     width: 100%;
//     // overflow: hidden;
//     .sg-nav {
//       position: relative;
//       height: 380px;
//       margin-top: 46px;
//       .oem-wrap {
//         position: relative;
//         float: right;
//         flex: 1;
//         .oem-box {
//           position: absolute;
//           // top: 36px;
//           top: 0;
//           box-sizing: border-box;
//           right: 0;
//           // width: 42.5%;
//           width: 100%;
//           height: 380px;
//           padding: 0 10px;
//           background-color: #fff;
//           z-index: 2;
//           overflow: hidden;
//           .oem-top {
//             height: 80px;
//             padding: 0 10px;
//             margin: 0 -10px;
//             background: #fff
//               url(data:image/png;base64,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)
//               no-repeat;
//             background-size: cover;
//             background-position: center;
//             > h3 {
//               padding: 10px 0 7px;
//               color: #333;
//               font-weight: bold;
//               font-size: 12px;
//               text-align: center;
//             }
//             .search {
//               position: relative;
//               font-size: 0;
//               display: flex;
//               input[type="text"] {
//                 box-sizing: border-box;
//                 width: 142px;
//                 height: 28px;
//                 padding: 4px 9px;
//                 border: 1px solid #ff4f1a;
//                 background-color: #fff;
//                 vertical-align: top;
//                 font-size: 12px;
//                 line-height: 18px;
//                 outline: none;
//                 &:focus {
//                   outline: none;
//                 }
//               }
//               .btn-search {
//                 flex: 1;
//                 display: inline-block;
//                 box-sizing: border-box;
//                 width: 28px;
//                 height: 28px;
//                 padding: 0 10px;
//                 color: #fff;
//                 background-color: #ff4f1a;
//                 font-size: 12px;
//                 line-height: 28px;
//                 text-align: center;
//                 transition: background-color 0.2s ease;
//                 &:hover {
//                   background-color: #d84e23;
//                 }
//               }
//             }
//           }
//           .oem-info {
//             margin: 12px 0;
//             > img {
//               float: left;
//               width: 40px;
//               height: 40px;
//               border-radius: 50%;
//               background-color: #f2f4f5;
//             }
//             > div {
//               margin-left: 48px;
//               line-height: 20px;
//               .link {
//                 color: #ff4f1a;
//                 span:not(:nth-child(2)) {
//                   cursor: pointer;
//                 }
//                 > span:nth-child(2) {
//                   margin: 0 4px;
//                 }
//               }
//             }
//           }
//           .order-stats {
//             margin: 10px -10px 12px;
//             line-height: 20px;
//             text-align: center;
//             cursor: pointer;
//             > li {
//               position: relative;
//               float: left;
//               -webkit-box-sizing: border-box;
//               box-sizing: border-box;
//               width: calc(100% / 3);
//               span {
//                 display: inline-block;
//                 color: #ff4f1a;
//                 vertical-align: top;
//                 font-weight: bold;
//                 font-size: 16px;
//               }
//               &:first-child::before {
//                 width: 0;
//               }
//               &::before {
//                 position: absolute;
//                 top: 4px;
//                 bottom: 4px;
//                 left: 0;
//                 width: 1px;
//                 background-color: rgba(0, 0, 0, 0.08);
//                 content: "";
//               }
//             }
//           }
//           .sign-box {
//             box-sizing: border-box;
//             height: 128px;
//             padding-top: 66px;
//             background: url(~@/assets/bg.png) no-repeat top center;
//             background-size: cover;
//             text-align: center;
//             > p {
//               line-height: 18px;
//               > span {
//                 margin-left: 4px;
//                 color: #ff4f1a;
//               }
//             }
//             > .button {
//               display: inline-block;
//               -webkit-box-sizing: border-box;
//               box-sizing: border-box;
//               width: 86px;
//               height: 24px;
//               border-radius: 12px;
//               margin-top: 5px;
//               color: #fff;
//               background-image: -webkit-gradient(
//                 linear,
//                 left top,
//                 right top,
//                 from(#ffa900),
//                 to(#ff7800)
//               );
//               background-image: linear-gradient(90deg, #ffa900, #ff7800);
//               background-color: #ff4f1a;
//               line-height: 24px;
//               text-align: center;
//               cursor: pointer;
//             }
//           }
//         }
//       }
//     }
//     .nav-home {
//       // padding: 0 calc(50% - 600px);
//       // position: relative;
//       // margin-top: 10px;
//       z-index: 20;
//       position: absolute;
//       top: -36px;
//       width: 100%;
//       left: 0;
//       // display: flex;

//       .car-style {
//         position: relative;
//         float: left;
//         width: 190px;
//         .car-title {
//           height: 36px;
//           border-radius: 8px 8px 0 0;
//           color: #fff;
//           background-color: #ff4f1a;
//           line-height: 36px;
//           > h3 {
//             float: left;
//             padding: 0 15px;
//             font-weight: bold;
//             font-size: 14px;
//           }
//           > .a {
//             float: right;
//             padding: 0 12px;
//             text-decoration: underline;
//           }
//         }
//       }
//       .car-list {
//         height: 380px;
//         color: #fff;
//         background-color: rgba(51, 62, 82, 0.5);
//         -webkit-backdrop-filter: blur(2px);
//         backdrop-filter: blur(2px);
//         position: absolute;
//         top: 36px;
//         left: 0;
//         width: 100%;
//         // background-color: #fff;
//         overflow-y: auto;
//         > li {
//           border-bottom: 1px solid rgba(255, 255, 255, 0.1);
//           .a {
//             display: inline-block;
//             -webkit-box-sizing: border-box;
//             box-sizing: border-box;
//             width: 100%;
//             padding: 9px 16px;
//             font-size: 0;
//             > span {
//               display: inline-block;
//               max-width: 112px;
//               //   margin-left: 14px;
//               font-size: 14px;
//               line-height: 28px;
//               &.single-ellipsis {
//                 overflow: hidden;
//                 text-overflow: ellipsis;
//                 white-space: nowrap;
//               }
//             }
//           }
//         }
//       }
//       .nav {
//         float: left;
//         padding: 0 20px;
//         li {
//           float: left;
//           .a {
//             // float: left;
//             height: 36px;
//             padding: 0 20px;
//             color: #333;
//             font-size: 15px;
//             line-height: 36px;
//             &.active {
//               color: #ff4f1a;
//               font-weight: bold;
//             }
//           }
//         }
//       }
//     }
//   }
//   .center {
//     // padding: 0 calc(50% - 600px);
//     .list {
//       margin-bottom: 10px;
//       background-color: #fff;
//       box-sizing: content-box;

//       > .list-header {
//         display: inline-block;
//         width: 100%;
//         > h2 {
//           float: left;
//           -webkit-box-sizing: border-box;
//           box-sizing: border-box;
//           min-width: 190px;
//           padding: 12px 18px;
//           font-size: 24px;
//         }
//         .list-keywords {
//           height: 24px;
//           padding: 18px 20px 0 0;
//           overflow: hidden;
//           font-size: 14px;
//           line-height: 24px;
//           > a {
//             display: inline-block;
//             -webkit-transition: color 0.2s ease;
//             transition: color 0.2s ease;
//             & + a {
//               margin-left: 30px;
//             }
//           }
//         }
//       }
//       > .list-content {
//         overflow: hidden;
//         position: relative;
//         .list-content-li {
//           padding: 20px 10px 20px 10px;
//           display: grid;
//           grid-template-columns: 100%;
//           grid-template-rows: 100%;
//           .list-content-box {
//             // display: grid;
//             // grid-template-columns: 60% 40%;
//             .list-item-wrap {
//               text-align: left;
//               display: flex;
//               flex-direction: column;
//               justify-content: space-between;
//               margin-right: 10px;
//               .left-title {
//                 font-size: 17px;
//               }
//               .list-item-desc {
//                 margin-top: 10px;
//                 line-height: 1.5;
//               }
//             }
//           }
//           .price-box {
//             height: 24px;
//             line-height: 24px;
//             color: #ff4f1a;
//             span {
//               margin-right: 5px;
//             }
//             b {
//               font-size: 18px;
//             }
//           }
//         }

//         > li {
//           position: relative;
//           float: left;
//           text-align: center;
//           box-sizing: border-box;
//           &:first-child {
//             width: 18%;
//             // min-width: 190px;
//             height: 360px;
//           }
//           &:nth-child(2),
//           &:nth-child(3),
//           &:nth-child(4),
//           &:nth-child(5) {
//             width: 32%;
//             height: 180px;
//             .list-content-box {
//               display: grid;
//               grid-template-columns: 60% 40%;
//             }
//           }
//           &:nth-child(6) {
//             width: 18%;
//             margin-top: -180px;
//             height: 360px;
//             .list-content-box {
//               display: grid;
//               .list-item-wrap {
//                 display: grid;
//                 grid-template-rows: 30% 50% 20%;
//                 grid-template-columns: 1fr;
//               }
//             }
//             img {
//               width: auto;
//             }
//           }
//           &:not(:last-child)::after {
//             position: absolute;
//             top: 0;
//             right: 0;
//             height: 100%;
//             content: "";
//             border-right: 1px solid #ebebeb;
//           }
//           //   &:not(:last-child)::before {
//           //     position: absolute;
//           //     bottom: 0;
//           //     left:  0;
//           //     width: 100%;
//           //     content: "";
//           //     border-bottom: 1px solid #ebebeb;
//           //   }
//           img {
//             width: 100%;
//             height: 100%;
//           }
//         }
//         &::after {
//           position: absolute;
//           top: 180px;
//           right: 18%;
//           left: 18%;
//           border-top: 1px solid #ebebeb;
//           content: "";
//         }
//       }
//       &:nth-of-type(1) {
//         > .list-header {
//           background-color: #f1fcf9;
//           > h2 {
//             color: #10c896;
//           }
//         }
//       }
//       &:nth-of-type(2) {
//         > .list-header {
//           background-color: #f2f8fe;
//           > h2 {
//             color: #2688ea;
//           }
//         }
//       }
//       &:nth-of-type(3) {
//         > .list-header {
//           background-color: #f5f5fe;
//           > h2 {
//             color: #5757e6;
//           }
//         }
//       }
//     }

//     // #div2 {
//     //   height: 1300px;
//     //   background: #2894f8;
//     // }

//     // #div3 {
//     //   height: 1200px;
//     //   background: orangered;
//     // }

//     // #div4 {
//     //   height: 1000px;
//     //   background: green;
//     // }

//     // #div5 {
//     //   height: 800px;
//     //   background: red;
//     // }
//   }
// }
</style>
//
<style lang="scss">
// .swiper-login-box {
//   .el-carousel__container {
//     height: 100%;
//     border-radius: 10px;
//     overflow: hidden;
//   }
// }
// .login-register-box {
//   .button-wrap {
//     .el-button {
//       padding-right: 25px;
//       padding-left: 25px;
//       border-radius: 50px;
//       font-size: 17px;
//       font-weight: 500;
//       color: rgba(255, 255, 255, 1);
//       &:nth-of-type(1) {
//         background: rgba(254, 118, 72, 1) !important;
//       }
//       &:nth-of-type(2) {
//         background: rgba(29, 32, 137, 1) !important;
//       }
//     }
//   }
// }
.full-screen-top {
	.el-carousel__container {
		// padding: 0 calc(50% - 30vw);
		position: static;
	}
	.el-carousel__item {
		// text-align: center;
		.carousel-item {
			// padding: 0 calc(50% - 600px);
			height: 100%;
		}
		&:nth-child(1) {
			background-color: rgb(0, 1, 111);
		}
		&:nth-child(2) {
			background-color: rgb(17, 143, 47);
		}
	}
}
.image-dialog-wrap {
	background-color: transparent !important;
	box-shadow: none !important;
	text-align: center;
	.el-dialog__header {
		display: none;
	}
	.el-dialog__body {
		padding: 0;
	}
	.close-bottom {
		color: #fff;
		padding-top: 30px;

		background-color: inherit;
		position: absolute;
		width: 100%;
		text-align: center;
		font-size: 49px;
	}
}
.sg-login-dialog {
	.el-dialog__header {
		padding: 10px 12px;
		background-color: #f2f4f5;
		position: relative;
		.el-dialog__headerbtn {
			top: 50%;
			transform: translateY(-50%);
		}
		.el-dialog__title {
			color: #666;
			font-size: 16px;
		}
	}
	.el-dialog__body {
		padding-top: 0;
	}
}
</style>
